import { DomainUpdateStatus } from '../enums/enumerations';

export interface DomainUpdateEventResultInterface {
  id?: string;
  domainId: string;
  platformOrigin: PlatformOrigin;
  originUser: string;
  createdDate?: Date;
  status?: DomainUpdateStatus;
  validationDate?: Date;
  orderId?: string;
  periodicity?: number | null;
  domainUpdateProductEvents: DomainUpdateProductEventResult[];
}

export interface DomainUpdateProductEventResult {
  id?: string;
  domainUpdateEventId?: string;
  productId: string;
  quantity: number;
  motifRetraitProductId?: string | null;
  MotifResiliationAutre?: string | null;
  codePromo?: string | null;
}

export enum PlatformOrigin {
  Client = 1,
  Commercial = 2,
  Revendeur = 3,
}

export interface BasketPricesPayload {
  periodicity: number;
  alpha2CodeCountry: string;
  tvaIntracommunity: string;
  basketItems: DomainUpdateProductEventRequest[];
  codePromo: string | null;
}

export interface DomainUpdateProductEventRequest {
  productId: string;
  codeProduct: number;
  quantity: number;
}

export interface BasketPricesDto {
  tva: number;
  totalHT: number;
  totalTTC: number;
  totalTVA: number;
}

export interface ProvisionalDatesRetraitDto {
  domainId: string;
  dateDemandeRetrait: Date;
  dateEffectiveRetrait: Date;
  dateSuppressionDonnees: Date;
  nextScheduledBillingDate: Date;
  dateFinPromo: Date;
  codePromo?: string;
}
